import httpClient from "@/_shared/http-client";
import { useNotification } from "@/_shared/mixins";
import { date } from "@/_shared/utils";
import { generators } from "@/authorization/utils";

const checkExistence = async (login = "") => {
  const fullUrl = new URL("/auth/existence", process.env.BACKEND_URL);
  fullUrl.searchParams.set("login", login);
  const response = await httpClient.get(fullUrl);
  return response;
};

const login = async (user = {}, password = null, snapshot = null) => {
  const fullUrl = new URL("/auth/login", process.env.BACKEND_URL);
  if (password) {
    fullUrl.searchParams.set("by_password", true);
    user.password = password;
  }
  const biometricForm = _prepareBiometricForm(user, snapshot);
  const passwordForm = _preparePasswordForm(user);
  const sendingData = password ? passwordForm : biometricForm;
  sendingData.user.authorized_at = date.getIsoString();
  const response = await httpClient
    .post(fullUrl, sendingData)
    .then((response) => {
      const { token, logged_today } = response.data;
      localStorage.setItem("token", token);
      return logged_today;
    });
  return response;
};

const addFailure = async (data = {}) => {
  const { user, snapshot, failure_reason } = data;
  const biometricForm = _prepareBiometricForm(user, snapshot);
  biometricForm.failure_reason = failure_reason;

  let results = null;
  const url = `${process.env.BACKEND_URL}/auth/failure`;
  await httpClient.post(url, biometricForm).then((response) => {
    results = response.data;
  });
  return results;
};

const _prepareBiometricForm = (user, snapshot) => ({
  snapshot,
  user,
  snapshot_name: generators.generateSnapshotName(user),
  created_at: date.getIsoString(),
});

const _preparePasswordForm = (user) => ({
  user,
});

const apiService = {
  login,
  checkExistence,
  addFailure,
};

export default apiService;



// WEBPACK FOOTER //
// ./src/authorization/apiService.js